export const clearAuthenticatedQueryCache = (queryClient) => {
  if (!queryClient || typeof queryClient.clear !== 'function') return;
  queryClient.clear();
};
